import { Component, inject } from '@angular/core';
import { SimulationFlowService } from '@services/simulation-flow.service';

@Component({
  selector: 'app-simulation-steps-bar',
  styleUrl: './simulation-steps-bar.component.scss',
  templateUrl: './simulation-steps-bar.component.html',
})
export class SimulationStepsBarComponent {
  private readonly flow = inject(SimulationFlowService);
  protected readonly currentStepNumber = this.flow.currentStepNumber;
  protected readonly currentStepTitle = this.flow.currentStepTitle;
  protected readonly progressRatio = this.flow.progressRatio;
  protected readonly totalSteps = this.flow.totalSteps;
}
